import React, { FC, Ref, useState } from 'react'
import StarIcon from '../../../public/static/icons/star.svg'
import css from './RateNum.module.scss'
import cx from 'classnames'

interface IRate {
  name: string
  id: string
  register?: Ref<HTMLInputElement>
  className?: string
  defaultRate?: number
}

const RateNum: FC<IRate> = ({
  name,
  id,
  register,
  className,
  defaultRate = 5,
}) => {
  const [rate, setRate] = useState(defaultRate)

  const renderStars = () => {
    const stars = []
    for (let i = 0; i < 5; i++) {
      stars.push(
        <StarIcon
          className={cx(css.star, rate > i && css.active)}
          viewBox="0 0 12 11"
          key={`review-star-${i}`}
          onClick={() => setRate(++i)}
        />,
      )
    }
    return stars
  }
  return (
    <div className={cx(css.wrapper, className)}>
      <p className={css.title}>Ваша оценка</p>
      <input
        className={css.input}
        name={name}
        id={id}
        ref={register}
        type="number"
        min={0}
        max={5}
        value={rate}
        readOnly
      />

      {renderStars()}
    </div>
  )
}

export default RateNum
